import { Navigate } from 'react-router-dom';
import { useSessionStorage } from '../../../hooks';
import React, { useState, useEffect } from 'react';
import { MainContainer,ContainerTitle,AcitveWorkerStatus, AcitveWorkerContainer, AcitveWorkerBox, AcitveWorkerImage, AcitveWorkerDetail, AcitveWorkerName, AcitveWorkerDesignation, AcitveWorkerScan, AcitveWorkerScanCount } from './styled';
import ActiveWorker from '../../../assets/activeWorker1.png';   
import * as apiClient from "../../../common/apiClient";
import * as App_Constant from "../../../common/constants";
export const FrontLineWorker = (props:any) => {
  const [authenticated, setAuthenticated] = useSessionStorage('authenticated');
  const [isLoadingActiveScan, setIsLoadingActiveScan] = useState(false);
  const [activeScan, setActiveScan] = useState<any[]>([]);
  const [remainingSeconds, setRemainingSeconds] = useState(App_Constant.AUTO_REFRESH_INTERVAL); // Set your desired interval
  const [lastRefreshTime, setLastRefreshTime] = useState<any>(null);
  useEffect(() => {
    loadActiveScan(); 
  }, []);
  const loadActiveScan = () => {
    //setActiveScan([]);
    apiClient.get(`requests/getActiveUserScan/${localStorage.getItem("business_partner_id")}`, null).then((response: any) => {
      if (response) {
        setActiveScan(response.activeScan); 
      }
      //setIsLoadingActiveScan(false);
    }).catch((err) => {
      //setIsLoadingActiveScan(false);
    })
  };
  useEffect(() => {
    const refreshInterval = setInterval(() => {
      // Call the API to refresh activeScan
      loadActiveScan();
      
     // loadActiveFLW();
      setLastRefreshTime(new Date()); // Update last refresh time
      setRemainingSeconds(App_Constant.AUTO_REFRESH_INTERVAL); // Reset remaining seconds
    }, App_Constant.AUTO_REFRESH_INTERVAL * 1000);

    // Clear interval on component unmount
    return () => clearInterval(refreshInterval);
  }, []); // Removed [remainingSeconds]

  // Update remaining seconds and last refresh time every second
  useEffect(() => {
    const countdownInterval = setInterval(() => {
      if (remainingSeconds > 0) {
        setRemainingSeconds((prev) => prev - 1);
      } else {
        setLastRefreshTime(new Date());
        setRemainingSeconds(App_Constant.AUTO_REFRESH_INTERVAL);
      }
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(countdownInterval);
  }, [remainingSeconds]);


  if (authenticated)
    return ( <>
      {!isLoadingActiveScan && <MainContainer>
          <ContainerTitle> Active Front Line Workers </ContainerTitle>
          <AcitveWorkerContainer> 
          {activeScan != null && activeScan != undefined && activeScan.length > 0 && activeScan.map((item, index) => { 
            return <AcitveWorkerBox>
              <AcitveWorkerImage src={ActiveWorker}/>
              <AcitveWorkerDetail>
                <AcitveWorkerName>
                {item.full_name}
                </AcitveWorkerName>
                <AcitveWorkerDesignation>
                Technical Advisor
                </AcitveWorkerDesignation>
               
              </AcitveWorkerDetail>
              <AcitveWorkerScan>
                Active Scan :
              </AcitveWorkerScan>
              <AcitveWorkerScanCount>
                {item.active_scan}
              </AcitveWorkerScanCount>
              <AcitveWorkerStatus>
                 Active
              </AcitveWorkerStatus>
            </AcitveWorkerBox>
          })}
          </AcitveWorkerContainer>
      </MainContainer>
}
      </>

    );
  return <Navigate to='/' replace />;

};
